<div #stickContainer [ngClass]="'app-sticky-' + group" [attr.data-stick]="'false'">
  <div id="sticky_header_id" *ngIf="ready" class="sticky-content" [ngClass]="(elem.nativeElement.dataset.stick == 'true' ? 'is-sticky' : '') + (adjustedSmall ? ' adjusted-small' : '') + (adjustedBig ? ' adjusted-big' : '') + (dropShadow ? ' drop-shadow-on' : '')">
    <ng-content select=".div-body"></ng-content>
  </div>
</div>